<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{$t('i18n.apk_update')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('i18n.apk_mange')}}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-container">
      <el-card>
        <span style="padding-left:20px">
          <el-col :span="3">
            <el-input :placeholder="$t('i18n.column.name_search')" v-model="queryInfo.apkName" @keyup.enter.native="getApkList" clearable @clear="getApkList">
              <el-button slot="append" icon="el-icon-search" @click="getApkList"></el-button>
            </el-input>
          </el-col>
          <el-button type="primary" round @click="addApk" class="btn-add" size="small"> {{$t('i18n.app_add')}} </el-button>
        </span>
        <span style="padding-left:20px">
          <el-col :span="3">
            <el-input :placeholder="$t('i18n.column.unicode_search')" v-model="queryInfo.apkCode" @keyup.enter.native="getApkList" clearable @clear="getApkList">
              <el-button slot="append" icon="el-icon-search" @click="getApkList"></el-button>
            </el-input>
          </el-col>

        </span>
      </el-card>

      <div class="table-container">
        <el-table :data="apkList">
          <el-table-column label="ID"  prop="id"></el-table-column>
          <el-table-column :label="$t('i18n.column.app_name')" prop="apkName"></el-table-column>
          <el-table-column :label="$t('i18n.column.app_code')" prop="apkCode"></el-table-column>
          <el-table-column :label="$t('i18n.column.create_time')" prop="createTime"></el-table-column>
          <el-table-column :label="$t('i18n.column.app_desc')" :show-overflow-tooltip="true"  prop="desc"></el-table-column>
          <el-table-column :label="$t('i18n.column.operator')" fixed="right"  >
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeById(scope.row.id)">
              </el-button>
              <el-button type="warning" round icon="el-icon-edit" size="mini" @click="editApk(scope.row)"  >{{$t('i18n.update')}}</el-button>
                         <el-button type="info" round icon="el-icon-right" size="mini" @click="handeleAppVersion(scope.row)">{{$t('i18n.app_version_query')}}
              </el-button>
            </template>

          </el-table-column>
          <!-- <el-table-column label="版本">
            <template slot-scope="scope">
              <el-button type="info" round icon="el-icon-right" size="mini" @click="handeleAppVersion(scope.row)">查看版本
              </el-button>
            </template>

          </el-table-column> -->
        </el-table>
      </div>
      <div class="paginnation-container">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNo" :page-sizes="[5, 10, 15, 20]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize" background></el-pagination>
      </div>
      <el-dialog :title="$t('i18n.app_add')" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
        <!-- 内容主体区域 -->
        <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
          <el-form-item label="APP NAME" label-width="120px" prop="apkName">
            <el-input v-model="addForm.apkName" :placeholder="$t('i18n.column.app_name')" s></el-input>
          </el-form-item>
          <el-form-item label="APP CODE" prop="encryptionKey" label-width="120px">
            <el-input v-model="addForm.encryptionKey" :placeholder="$t('i18n.column.app_code_placeholder')"></el-input>
          </el-form-item>
          <el-form-item label="APP DESC" prop="desc" label-width="120px">
            <el-input type='textarea' v-model="addForm.desc" :placeholder="$t('i18n.column.app_desc')" :autosize="{ minRows: 10, maxRows: 80}"></el-input>
          </el-form-item>
        </el-form>
        <!-- 底部区域 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
          <el-button type="primary" @click="addOrUpdateApk">{{$t('i18n.confirm')}}</el-button>
        </span>
      </el-dialog>

    </div>

  </div>
</template>

<script>
const defaultListQuery = {
    apkName: '',
    apkCode: '',
    pageNo: 1,
    pageSize: 15
};

export default {
    data() {
        return {
            apkList: [],
            totalSize: 0,
            queryInfo: Object.assign({}, defaultListQuery),
            addDialogVisible: false,
            isEdit: false,
            addForm: {
                id:null,
                apkName: '',
                encryptionKey: '',
                desc: ''
            },
            addFormRules: {
                apkName: [{ required: true, message: this.$t('i18n.validate.app_name_need'), trigger: 'blur' }],
                encryptionKey: [{ required: true, message: this.$t('i18n.validate.app_package_name_need'), trigger: 'blur' }],
                desc: [{ required: true, message: this.$t('i18n.validate.app_desc_need'), trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getApkList();
    },
    methods: {
        addApk() {
            this.isEdit = false;
            this.addDialogVisible = true;
        },
        editApk(row) {
            this.addDialogVisible = true;
            this.isEdit = true;
            this.addForm.id = row.id;
            this.addForm.apkName=row.apkName;
            this.addForm.encryptionKey = row.encryptionKey;
            this.addForm.desc = row.desc;
        },
        getApkList() {
            this.$http
                .get('/apk/apkInfoQueryPage', {
                    params: this.queryInfo
                })
                .then(res => {
                    res = res.data;
                    if (res.code != 0) {
                        return this.$message.error(res.msg);
                    }
                    this.apkList = res.data.list;
                    this.totalSize = res.data.totalSize;
                });
        },
        async removeById(id) {
            const confirmResult = await this.$confirm(this.$t('i18n.is_delete_continue'), this.$t('i18n.tip'), {
                confirmButtonText: this.$t('i18n.confirm'),
                cancelButtonText: this.$t('i18n.cancel'),
                type: 'warning'
            }).catch(err => err);

            if (confirmResult !== 'confirm') {
                return this.$message.info(this.$t('i18n.had_cancel_delete'));
            }
            const { data: res } = await this.$http.post('/apk/apkDelete?id=' + id);

            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(this.$t('i18n.success'));
            this.getApkList();
        },
        // 监听对话框的关闭事件
        addDialogClosed() {
            this.$refs.addFormRef.resetFields();
        },
        addOrUpdateApk() {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return;
                const { data: res } = await this.$http.post(this.isEdit?'/apk/apkUpdate':'/apk/apkCreate', this.addForm);
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                } else {
                    this.$message.success(this.$t('i18n.success'));
                    this.addDialogVisible = false; //关闭对话框
                    this.getApkList();
                }
            });
        },
        handeleAppVersion(param) {
            this.$router.push({
                path: 'apkVersion',
                query: {
                    apkId: param.id,
                    apkName: param.apkName
                }
            });
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getApkList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNo = newPage;
            this.getApkList();
        }
    }
};
</script>

<style scoped>
.el-pagination {
    text-align: right;
}
</style>
